import React, { createRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import * as Text from '@commoncomponents/frontend-components/dist/components/Text';
import Tooltip from '@commoncomponents/frontend-components/dist/components/Tooltip';
import { colors, breakpoints, fontName, fontSizes, } from '@commoncomponents/frontend-components/dist/styled';
import { getExpirationDateAfterDays, getExpirationDateAfterMonths, } from '../utils';
import { BillingCycleUnit } from '../constants';
const CodeActivationData = ({ userFullName, userEmail, activatedPlanDataLabel, expirationText, userDataLabel, youText, isCurrentUser, newPlanInfo, }) => {
    const { name, expirationTime, duration } = newPlanInfo;
    const [isEmailTextOverflowing, setIsEmailTextOverflowing] = useState(false);
    const emailTextRef = createRef();
    const getExpirationDate = () => {
        const { unit, count } = expirationTime;
        switch (unit) {
            case BillingCycleUnit.DAY:
                return getExpirationDateAfterDays(count);
            case BillingCycleUnit.MONTH:
                return getExpirationDateAfterMonths(count);
        }
    };
    useEffect(() => {
        if (emailTextRef.current) {
            const isOverflowing = emailTextRef.current.offsetWidth !== emailTextRef.current.scrollWidth;
            setIsEmailTextOverflowing(isOverflowing);
        }
    }, []);
    return (React.createElement(Wrapper, null,
        React.createElement(DataSection, null,
            React.createElement(Text.Body, { color: colors.rockyGrey }, activatedPlanDataLabel),
            React.createElement(DataDetails, null,
                React.createElement(Text.Subheading2, null, name),
                React.createElement(Text.Body, null,
                    React.createElement(React.Fragment, null,
                        expirationText,
                        ` ${getExpirationDate()} (${duration})`)))),
        React.createElement(DataSection, null,
            React.createElement(Text.Body, { color: colors.rockyGrey }, userDataLabel),
            React.createElement(DataDetails, null,
                React.createElement(Text.Subheading2, null,
                    React.createElement(React.Fragment, null,
                        userFullName,
                        isCurrentUser && youText)),
                React.createElement(Tooltip, { disabled: !isEmailTextOverflowing, maxWidth: 300, message: userEmail, preferredPlacement: "top", theme: "dark", hasInteractiveContent: true },
                    React.createElement(TextWrapper, null,
                        React.createElement(EmailText, { ref: emailTextRef }, userEmail)))))));
};
const Wrapper = styled.div `
  background-color: ${colors.rousingPearl};
  border-radius: 8px;
  padding-bottom: 16px;
`;
const DataSection = styled.div `
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 16px 16px 0;
`;
const DataDetails = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 8px;
  width: 100%;

  div:first-child {
    text-align: start;
    word-break: break-word;
  }

  @media ${breakpoints.md} {
    align-items: flex-start;
    flex-direction: column;
  }
`;
const TextWrapper = styled.span `
  display: inline-flex;
  max-width: 260px;
  padding-left: 16px;
  @media ${breakpoints.md} {
    padding-left: 0;
  }
`;
const EmailText = styled.span `
  font-family: ${fontName};
  font-size: ${fontSizes.body};
  letter-spacing: 0.04px;
  line-height: 22px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
export default CodeActivationData;
